module.exports = __webpack_public_path__ + "static/media/siddharth-amaravati-trip-11.07a64b50.png";